import { render, staticRenderFns } from "./ComplainLeft.vue?vue&type=template&id=31a3d238&scoped=true&"
import script from "./ComplainLeft.vue?vue&type=script&lang=js&"
export * from "./ComplainLeft.vue?vue&type=script&lang=js&"
import style0 from "./ComplainLeft.vue?vue&type=style&index=0&id=31a3d238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a3d238",
  null
  
)

export default component.exports